/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Airport_TerminalInputs */

const en_map_airport_terminal = /** @type {(inputs: Map_Airport_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Airport Terminal`)
};

const fr_map_airport_terminal = /** @type {(inputs: Map_Airport_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminal d'aéroport`)
};

const ms_sg2_map_airport_terminal = /** @type {(inputs: Map_Airport_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminal Lapangan Terbang`)
};

/**
* | output |
* | --- |
* | "Airport Terminal" |
*
* @param {Map_Airport_TerminalInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_airport_terminal = /** @type {((inputs?: Map_Airport_TerminalInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Airport_TerminalInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_airport_terminal(inputs)
	if (locale === "fr") return fr_map_airport_terminal(inputs)
	return ms_sg2_map_airport_terminal(inputs)
});